import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";
import logo from "../assets/logo.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
      setIsMenuOpen(false);
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <nav className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white shadow-lg border-b border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-6">
            <Link
              to="/"
              className="font-bold text-xl md:text-2xl hover:text-blue-400 flex items-center transition-colors duration-300"
            >
              <img
                src={logo}
                alt="Logo"
                className="h-8 md:h-10 w-auto transition-transform duration-300 transform hover:scale-110"
              />
            </Link>

            <div className="hidden md:flex space-x-2">
                <Link to="/ta" className={`px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
                  isActive("/ta") ? "bg-blue-600 text-white shadow-lg shadow-blue-600/30" : "hover:text-blue-400 hover:bg-gray-700/50"
                }`}>
                  TA
                </Link>
                <Link to="/ta-tools" className={`px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
                  isActive("/ta-tools") ? "bg-blue-600 text-white shadow-lg shadow-blue-600/30" : "hover:text-blue-400 hover:bg-gray-700/50"
                }`}>
                  TA Tools
                </Link>
                <Link to="/arbitrage" className={`px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
                  isActive("/arbitrage") ? "bg-purple-600 text-white shadow-lg shadow-purple-600/30" : "hover:text-purple-400 hover:bg-gray-700/50"
                }`}>
                  ⚡ Arbitrage
                </Link>
                <Link to="/mu-gap" className={`px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
                  isActive("/mu-gap") ? "bg-blue-600 text-white shadow-lg shadow-blue-600/30" : "hover:text-blue-400 hover:bg-gray-700/50"
                }`}>
                  MU Gap
                </Link>
                <Link to="/btc-quarterly" className={`px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
                  isActive("/btc-quarterly") ? "bg-blue-600 text-white shadow-lg shadow-blue-600/30" : "hover:text-blue-400 hover:bg-gray-700/50"
                }`}>
                  BTC Quarterly
                </Link>
                {user && (
                  <Link to="/dashboard" className={`px-4 py-2 rounded-lg transition-all duration-300 font-medium ${
                    isActive("/dashboard") ? "bg-blue-600 text-white shadow-lg shadow-blue-600/30" : "hover:text-blue-400 hover:bg-gray-700/50"
                  }`}>
                    Dashboard
                  </Link>
                )}
              </div>
          </div>

          <div className="flex items-center space-x-4">
            {user && (
              <div className="hidden md:block">
                <button
                  onClick={handleLogout}
                  className="px-6 py-2 bg-red-600 rounded-lg hover:bg-red-700 transition-colors duration-300 font-medium shadow-md"
                >
                  Logout
                </button>
              </div>
            )}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    {isMenuOpen ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    ) : (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    )}
                  </svg>
                </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-gray-800 rounded-lg mt-2">
              <Link
                to="/ta"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/ta") ? "bg-blue-600 text-white" : "text-white hover:text-blue-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                TA
              </Link>
              <Link
                to="/ta-tools"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/ta-tools") ? "bg-blue-600 text-white" : "text-white hover:text-blue-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                TA Tools
              </Link>
              <Link
                to="/arbitrage"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/arbitrage") ? "bg-purple-600 text-white" : "text-white hover:text-purple-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                ⚡ Arbitrage
              </Link>
              <Link
                to="/mu-gap"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/intel") ? "bg-blue-600 text-white" : "text-white hover:text-blue-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Intel
              </Link>
              <Link
                to="/mu-gap"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/mu-gap") ? "bg-blue-600 text-white" : "text-white hover:text-blue-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                MU Gap
              </Link>
              <Link
                to="/btc-monthly"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/btc-monthly") ? "bg-blue-600 text-white" : "text-white hover:text-blue-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                BTC Quarterly
              </Link>
              {user && (
              <Link
                to="/dashboard"
                className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-300 ${
                  isActive("/dashboard") ? "bg-blue-600 text-white" : "text-white hover:text-blue-400 hover:bg-gray-700"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Dashboard
              </Link>
              )}
              {user && (
              <button
                onClick={handleLogout}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-white bg-red-600 hover:bg-red-700 transition-colors duration-300"
              >
                Logout
              </button>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
